import storage from "../utils/storage/storage";
import { ICachedAddin } from "./databaseCache";

/**
 * Translation service for Drive App addins.
 * Reads the translation dictionary from the addin's cached localStorage entry.
 */
export default class AddinTranslationService {

    private readonly storageKey: string;

    /**
     * @param storageKey The LocalStorage key containing the translation dictionary.
     */
    constructor(storageKey: string) {
        this.storageKey = storageKey;
    }

    /**
     * Translates all translatable text nodes within an HTMLElement.
     */
    translateElement = (element: HTMLElement) => {
        let i;
        let childNodes = element.childNodes;
        let attributesToTranslate = ["placeholder", "title", "aria-label"];

        for (i = 0; i < childNodes.length; i++) {
            let childNode = childNodes[i] as HTMLElement;

            if (childNode.nodeType === 3) {
                childNode.textContent = this.translateStr(childNode.textContent || "");
            } else if (childNode.nodeType === 1) {
                this.translateElement(childNode);

                childNode.getAttribute && attributesToTranslate.forEach(attributeName => {
                    let attributeValue = childNode.getAttribute(attributeName);
                    if (attributeValue) {
                        childNode.setAttribute(attributeName, this.translateStr(attributeValue));
                    }
                });
            }
        }

        return element;
    };

    /**
     * Looks up a string in the translation dictionary. Returns the original if not found.
     */
    translateStr = (str: string): string => {
        let cachedAddin: ICachedAddin = storage.get(this.storageKey, true, "ADDIN") || <ICachedAddin>{ html: "", translation: {} };
        let cleanArg = str.trim();

        if (cleanArg.length !== 0) {
            if (typeof cachedAddin.translation[cleanArg as keyof typeof cachedAddin.translation] !== "undefined") {
                return cachedAddin.translation[cleanArg as keyof typeof cachedAddin.translation];
            }

            return cleanArg;
        }

        return str;
    };

    /**
     * Translates a string or an HTMLElement.
     */
    translate = (arg: string | HTMLElement) => {
        if (arg) {
            if (typeof arg === "string") {
                return this.translateStr(arg);
            }

            this.translateElement(arg);
        }

        return arg;
    };
}
